import React, {memo} from 'react'
import {Breadcrumb, Button, Grid, Table} from 'semantic-ui-react'
import {withAccountsData, withErrorHandling, withHelmet, withMeData, withPropsPresent} from '../../hoc'
import {loginAsSuperUser, logoutAsSuperUser} from '../../backend'
import {userName, userEmail, toLocaleString, coerceToISODate} from '../../util'

const _SuperUserAccounts = (
  {
    me,
    navigate,
    accounts = [],
    loginAsSuperUser,
    logoutAsSuperUser
  }
) => {
  const onLogin = async (e, accountId) => {
    e.preventDefault()
    await loginAsSuperUser(accountId)
    window.location.href = '/c/services'
  }

  const onLogout = async (e) => {
    e.preventDefault()
    await logoutAsSuperUser()
    window.location.reload()
  }

  const {superUserAccount = {}} = me
  const superUserAccountId = superUserAccount.id

  return (
    <Grid divided='vertically'>
      <Grid.Row coloumns='16'>
        <Grid.Column width='16'>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={() => navigate('/')}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider/>
            <Breadcrumb.Section active>Super User</Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns='16'>
        <Grid.Column width='16'>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>User Name</Table.HeaderCell>
                <Table.HeaderCell>User Email</Table.HeaderCell>
                <Table.HeaderCell>Plan</Table.HeaderCell>
                <Table.HeaderCell>Last Activity</Table.HeaderCell>
                <Table.HeaderCell>Users</Table.HeaderCell>
                <Table.HeaderCell>Services</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                accounts.map((a) => (
                  <Table.Row key={a.id} active={superUserAccountId === a.id}>
                    <Table.Cell><span title={a.id}>{a.name}</span></Table.Cell>
                    <Table.Cell>{userName(a.startedByUser)}</Table.Cell>
                    <Table.Cell>{userEmail(a.startedByUser)}</Table.Cell>
                    <Table.Cell>{a.plan}</Table.Cell>
                    <Table.Cell>{a.lastActivityAt ? toLocaleString(coerceToISODate(a.lastActivityAt)) : 'n/a'}</Table.Cell>
                    <Table.Cell>{a.stats.userCount !== undefined ? a.stats.userCount : 'n/a'}</Table.Cell>
                    <Table.Cell>{a.stats.serviceCount !== undefined ? a.stats.serviceCount : 'n/a'}</Table.Cell>
                    {
                      superUserAccountId !== a.id && (
                        <Table.Cell><Button onClick={(e) => onLogin(e, a.id)}>Login</Button></Table.Cell>)
                    }
                    {
                      superUserAccountId === a.id && (
                        <Table.Cell><Button onClick={(e) => onLogout(e)}>Logout</Button></Table.Cell>)
                    }
                  </Table.Row>
                ))
              }
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

let SuperUserAccounts = (props) => {


  const {handleError} = props
  props = {...props, loginAsSuperUser: handleError(loginAsSuperUser), logoutAsSuperUser: handleError(logoutAsSuperUser)}

  return (
    <_SuperUserAccounts {...props}/>
  )
}


SuperUserAccounts = withPropsPresent(SuperUserAccounts, ['me', 'accounts'])
SuperUserAccounts = withHelmet(SuperUserAccounts, 'All Accounts')
SuperUserAccounts = withMeData(SuperUserAccounts, 'Loading profile...')
SuperUserAccounts = withAccountsData(SuperUserAccounts, 'Loading accounts...')
SuperUserAccounts = withErrorHandling(SuperUserAccounts)
SuperUserAccounts = memo(SuperUserAccounts)

export {_SuperUserAccounts, SuperUserAccounts}

export default SuperUserAccounts